module.exports = __webpack_public_path__ + "img/104.accea483.jpg";